import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import "../../common.css";
import "../../investorAcademy.css";



const ExercisePrices = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main">
                <div id="maintable" className='share_capital Common_warrent' style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }} />
                                                            <div className="prevname " style={{ textAlign: 'left' }}>Share Price</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>How are Warrants priced?</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>Exercise Price</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }} />
                                                            <div className="nextname " style={{ textAlign: 'right' }}>Expiry Date</div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><div className="next right" /></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                                        {/*<link rel="stylesheet" href="css/common.css"/>*/}
                                        <title>Exercise Price</title>
                                        <div className="contentbox">
                                            <p>Also commonly known as Strike Price, this is the fixed price at which investors are entitled to buy the underlying share on the expiry date for call warrants (or sell, in the case of put warrants). As such, the higher this price, the less likely the call warrant will be exercised and hence, the less value ascribed to the warrant. Conversely, in the case of a put warrant, the higher the price at which you are able to sell the asset on a future date, the more likely the put warrant is to be exercised and hence, a higher value ascribed to that warrant.</p>
                                            <div className="imgholder11">
                                                <img style={{ maxWidth: '800px' }} src='/img/education/ep.png' alt="image" />
                                            </div>
                                            <div className="imgholder imgmask2">
                                                <img style={{ maxWidth: '800px' }} src='/img/education/ep_m.png' alt="image" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                   <div className='copyright_sec'>
                   Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                    reserved.
                   </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/how-are-warrant-priced/expiry-date">
                                                Expiry Date
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                    <Link to="/edu/how-are-warrant-priced/expiry-date">
                                        <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                    <Link to="/edu/how-are-warrant-priced/share-price">
                                        <div className="prev left" />
                                    </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/how-are-warrant-priced/share-price">
                                                Share Price
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                    <Link
                        className="seminarbtn"
                        to="/education/seminar"
                    >
                        <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
    );
}
export default ExercisePrices;